// extracted by mini-css-extract-plugin
export default {"subLevelForm":"company-detail_subLevelForm__H5U40","date":"company-detail_date__syy2f","ant-picker-input":"company-detail_ant-picker-input__jaMiA"};